import type { FC, PropsWithChildren } from 'react'

import { twMerge } from 'tailwind-merge'

import { Swipeable } from './Swipeable'

export const Container: FC<
  PropsWithChildren<{
    className?: string
    onSwipedLeft?: () => void
  }>
> & { Header: typeof ContainerHeader } = ({ children, className, onSwipedLeft }) => (
  <Swipeable
    className={twMerge(
      'left-0 top-0 mx-auto w-full max-w-[1400px] bg-white p-4 pb-1 md:pb-0',
      className
    )}
    onSwipedLeft={onSwipedLeft && onSwipedLeft}
  >
    {children}
  </Swipeable>
)

const ContainerHeader: FC<PropsWithChildren> = ({ children }) => (
  <h2 className="mt-0">{children}</h2>
)

Container.Header = ContainerHeader
